export const baseURL = "https://control.jonakilive.online/";
export const key = "796576d4cd950f45b79a5c8f73466470891248baa56fa397a297f69d8cbef500";
